<template>
  <el-form-item :label="$t('merchandisingModules.merchOrderSearch.deliveryStaff')">
    <el-select
      :placeholder="$t('common.pleaseSelect')"
      @change="selectChange"
      v-model="generate_id"
      clearable
      filterable
      remote
      :remote-method="remoteMethod"
      style="width: 100%"
    >
      <el-option
        v-for="item in options"
        :label="item.label"
        :value="item.value"
        :key="item.value"
      ></el-option>
    </el-select>
  </el-form-item>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { getGenerateName } from '@/api/talling-manager/operation-log'

const generate_id = ref(),
  options = ref([]),
  emit = defineEmits(['change'])

onMounted(() => {
  getList()
})

const remoteMethod = (query) => {
  getList(query)
}

async function getList(name) {
  const params = {
    name,
    page: 1,
    size: 10,
  }
  const { result } = await getGenerateName(params)
  if (result) {
    options.value = result.data.rows.map((item) => {
      return {
        value: item.id,
        label: item.name,
      }
    })
  }
}

function clear() {
  generate_id.value = undefined
}

function selectChange(e) {
  emit('change', e)
}

defineExpose({
  clear,
})
</script>

<style lang="scss" scoped></style>
